import React from 'react';
import ReactDom from 'react-dom';
import auth from '../../../base/auth';
import styles from './index.css';
const { event, LOGINURL, closeDialog, EVENTNAMES } = auth;
const createMarkup = (src) => {
    return {
        __html: `<iframe width="520" height="410" scrolling="no" frameborder="no" border="0" style="border:0px; margin:0px;padding:0px;" src="${src}"></iframe>`,
    };
};
export default class LoginDialog extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isOpen: false,
            src: LOGINURL,
        };
        this.closeHandle = () => {
            closeDialog();
        };
    }
    componentDidMount() {
        this.unbindDialogOpen = event.on(EVENTNAMES.dialogOpen, (src = LOGINURL, id) => {
            if (id === this.props.id) {
                this.setState({
                    isOpen: true,
                    src,
                });
            }
        });
        this.unbindDialogClose = event.on(EVENTNAMES.dialogClose, () => {
            this.setState({
                isOpen: false,
                src: LOGINURL,
            });
        });
        this.unBindUrlChang = event.on(EVENTNAMES.urlChange, (url) => {
            this.setState({
                src: url,
            });
        });
    }
    componentWillUnmount() {
        this.unbindDialogOpen();
        this.unbindDialogClose();
        this.unBindUrlChang();
    }
    render() {
        const { isOpen, src } = this.state;
        return isOpen
            ? ReactDom.createPortal([
                React.createElement("div", { className: styles.mask, key: "mask" }),
                React.createElement("div", { className: styles.box, key: "box" },
                    React.createElement("div", { className: styles.close, onClick: this.closeHandle }),
                    React.createElement("div", { dangerouslySetInnerHTML: createMarkup(src) })),
            ], document.body)
            : null;
    }
}
